var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPromo === true)?_c('section',{staticClass:"wrapper"},[_vm._t("default"),_c('button',{on:{"click":_vm.close}},[_vm._v("Close")])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }